module.exports = __webpack_public_path__ + "static/media/8.64d5ffd6.jpeg";